export default {
  state: {
    unity: {},
    updateUnity: false,
    procedures: [],
    coverage: [],
  },

  getters: {
    getUnityData(state) {
      return state.unity;
    },

    getUnityCrudType(state) {
      return state.updateUnity;
    },

    getProcedures(state) {
      return state.procedures;
    },

    getCoverageData(state) {
      return state.coverage;
    },
  },

  mutations: {
    setUnityData(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.unity = {
        id: isUpdate ? data.id : "",
        cnes: isUpdate ? data.cnes : "",
        name: isUpdate ? data.name : "",
        company_name: isUpdate ? data.company_name : "",
        responsible: isUpdate ? data.responsible : "",

        phone1: isUpdate ? data.phone1 : "",
        phone2: isUpdate ? data.phone2 : "",
        cellphone: isUpdate ? data.cellphone : "",
        email: isUpdate ? data.email : "",

        cep: isUpdate ? data.cep : "",
        public_place: isUpdate ? data.public_place : "",
        number: isUpdate ? data.number : "",
        district: isUpdate ? data.district : "",
        complement: isUpdate ? data.complement : "",
        city: isUpdate ? data.city : "",
        health_region_id: isUpdate ? parseInt(data.health_region_id) : "",
        macro_region_id: isUpdate ? parseInt(data.macro_region_id) : "",
        uf: isUpdate ? data.uf : "",

        sphere_id: isUpdate ? parseInt(data.sphere_id) : "",
        organization_nature_id: isUpdate ? parseInt(data.organization_nature_id) : "",
        unity_type_id: isUpdate ? parseInt(data.unity_type_id) : "",
        accreditation_level_id: isUpdate ? parseInt(data.accreditation_level_id) : "",

          aghuse_code: isUpdate ? Number(data.aghuse_code) : "",
        coverage: isUpdate ? data.coverage : []

      };

      state.updateUnity = isUpdate;
    },

    setProcedures(state, procedures) {
      state.procedures = procedures;
    },

    setUpdateProcedures(state, data) {
      state.unity.procedureOccupation = data;
    },

    setCoverageData(state, data) {

      state.coverage = {
        counties: data.length > 0 ? data.counties : []
      };

      state.coverage = data;
    },
  },

  actions: {
    changeUnityData(context, data) {
      context.commit("setUnityData", data);
    },

    changeProcedures(context, procedures) {
      context.commit("setProcedures", procedures);
    },

    changeDataProcedureOccupationData(context, data) {
      context.commit("setUpdateProcedures", data);
    },

    changeCoverageData(context, data) {
      context.commit("setCoverageData", data);
    },
  },
};
